export default __webpack_public_path__ + "static/media/14.69a759ca.PNG";